import { Navigate, useLocation } from 'react-router-dom'
import { useStore } from '../../store/useStore'
import { useEffect, useState } from 'react'

const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated, checkAuth } = useStore()
  const location = useLocation()
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    // Vérifier d'abord s'il y a une session dans localStorage
    const simpleSession = localStorage.getItem('admin_session_simple')
    
    if (simpleSession) {
      // Si une session existe, forcer la vérification
      checkAuth()
    }
    
    // Attendre un peu pour que le store se mette à jour
    setTimeout(() => {
      setIsChecking(false)
    }, 100)
  }, [checkAuth])

  // Afficher un loader pendant la vérification
  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification...</p>
        </div>
      </div>
    )
  }

  // Vérifier l'authentification
  if (!isAuthenticated || user?.role !== 'admin') {
    console.log('ProtectedRoute: Not authenticated, redirecting to login')
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  console.log('ProtectedRoute: Authenticated, showing content')
  return children
}

export default ProtectedRoute
